module.exports = __webpack_public_path__ + "img/popup_lose.d7afec8b.png";